/**
 * /status + /status/verify localized copy. Re-export shim over
 * /locales/{en,ht,fr,es}.json (status key, with .page + .verify sub-keys).
 * See /locales/README.md.
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.status,
  ht: ht.status,
  fr: fr.status,
  es: es.status,
  'pt-BR': ptBR.status,
  'zh-Hans': zhHans.status,
}

export default COPY
